// Partes de la app que se bajan recién cuando se usan (el armado del PDF, el Excel). 22-oct-2026:
// si la pestaña quedó abierta desde antes de una actualización, esa parte ya no existe en el
// servidor con el nombre viejo y fallaba con "No se pudo armar el PDF". Ahora se recarga la página
// una vez (queda la versión nueva) y el usuario vuelve a tocar el botón.
export function esVersionVieja(e) {
    const m = String(e?.message || '');
    return e?.name === 'ChunkLoadError' || /Loading (CSS )?chunk|dynamically imported module|Importing a module script failed/i.test(m);
}

export async function importarModulo(cargar) {
    try {
        const mod = await cargar();
        try { sessionStorage.removeItem('recarga_por_version'); } catch { /* */ }
        return mod;
    } catch (e) {
        let yaRecargo = false;
        try { yaRecargo = sessionStorage.getItem('recarga_por_version') === '1'; } catch { /* */ }
        if (esVersionVieja(e) && !yaRecargo) {
            try { sessionStorage.setItem('recarga_por_version', '1'); } catch { /* */ }
            window.location.reload();
            return new Promise(() => {});   // no sigue: la página se está recargando
        }
        throw e;
    }
}
